import { getApi } from "../utils/api";
import { GET_ALL_EMPLOYEES_NAME } from "../config/Endpoints";
import Cookies from "js-cookie";

export const fetchEmployeeNamesListService = async (set) => {
  set({ loading: true });
  try {
    const accessToken = Cookies.get("accessToken");
    const res = await getApi(GET_ALL_EMPLOYEES_NAME, accessToken);

    const users = res.data?.data || [];
    const options = users.map((u) => ({
      value: u.id,
      label: u.empName,
    }));

    set({ employeeList: options });
  } catch (err) {
    console.error("Error fetching employees:", err);
  } finally {
    set({ loading: false });
  }
};
